import type { ViewComponent } from "@frui.ts/views";
import type RefundChargeViewModel from "viewModels/callCenter/search/charges/refundChargeViewModel";
import { observer } from "mobx-react-lite";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import { formatDate } from "utils/localizations";
import React from "react";
import ChangedChargeProperty from "../../../../../entities/changedChargeProperty";

export const ChangesDuringValidityWarning: ViewComponent<RefundChargeViewModel> = observer(({ vm }) => {
  if (!vm.changesDuringValidity) {
    return null;
  }

  const newCountryId = vm.chargeResponse.vehicle.countryId;
  const newLicensePlate = vm.chargeResponse.vehicle.licensePlate;

  const originalLicensePlate =
    vm.changesDuringValidity.changes.find(change => change.changedProperty === ChangedChargeProperty.LicensePlate)
      ?.originalValue ?? newLicensePlate;
  const originalCountryId =
    vm.changesDuringValidity.changes.find(change => change.changedProperty === ChangedChargeProperty.Country)?.originalValue ??
    newCountryId;

  function formatLicensePlate(countryId: string, licensePlate: string) {
    return `${vm.translateCountry(countryId)} - ${licensePlate}`;
  }

  return (
    <>
      <div className="bg-danger rounded-top text-white px-4 py-3 font-weight-bolder mt-4">
        {vm.translate("changesDuringValidity")}
      </div>
      <div className="bg-danger-light rounded-bottom px-4 py-3">
        <Form.Row>
          <Form.Group as={Col} sm={4} xs={6}>
            <Form.Label>{vm.translateAttribute("chargeChangesDuringValidityItemResponse", "changedAt")}</Form.Label>
            <div className="text-break">{formatDate(vm.changesDuringValidity.changedAt)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={4} xs={6}>
            <Form.Label>{vm.translate("changeType")}</Form.Label>
            <div className="text-break">{vm.translate("licensePlateChange")}</div>
          </Form.Group>
          <Form.Group as={Col} sm={4} xs={6}>
            <Form.Label>{vm.translateAttribute("chargeChangesDuringValidityItemResponse", "changeOrigin")}</Form.Label>
            <div className="text-break">{vm.translateChangeOrigin(vm.changesDuringValidity.changeOrigin)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={4} xs={6}>
            <Form.Label>{vm.translateAttribute("chargeChange", "originalValue")}</Form.Label>
            <div className="text-break">{formatLicensePlate(originalCountryId, originalLicensePlate)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={4} xs={6}>
            <Form.Label>{vm.translateAttribute("chargeChange", "newValue")}</Form.Label>
            <div className="text-break">{formatLicensePlate(newCountryId, newLicensePlate)}</div>
          </Form.Group>
        </Form.Row>
      </div>
    </>
  );
});

export default ChangesDuringValidityWarning;
